var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasePageLayout',[_c('div',{attrs:{"slot":"page__title"},slot:"page__title"},[_vm._v("Thống kê dữ liệu")]),_c('div',{staticClass:"pa-8"},[_c('TableStatistic',{attrs:{"items":_vm.statistic}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }